import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { isPresent } from '@mtna/core-ts';

@Pipe({
  name: 'rdsNumToString',
})
export class RdsNumberToStringPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    return isPresent(value) ? `${value}` : '';
  }
}

@NgModule({
  exports: [RdsNumberToStringPipe],
  declarations: [RdsNumberToStringPipe],
})
export class RdsNumberToStringPipeModule {}
